import { WorkBook } from "xlsx-js-style";
import * as XLSX from 'xlsx-js-style';
import { ExcelTemplate } from "../../../interfaces";
import { setColumnWidth, withHeaderStyling } from "../../../utils";
import { getPreparedDataInternal } from "./mapping";
import { RoundsFS } from "../../../../models/fund-strategy/pojo/fund-strategy-export-classes";
import { fitToColumn } from "../../../fitToColumn";

export class FundStrategyInternalTemplate implements ExcelTemplate {
  export(data: RoundsFS[]): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(data: RoundsFS[]): XLSX.WorkSheet {

    const preparedData = getPreparedDataInternal(data);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [6, 10, 14, 16];
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }
}
